module.exports = __webpack_public_path__ + "static/stars5_0-a36addb042817a2ecf4d369feac87a01.png";